import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import IDCardGeneratorMBTI from "./pages/IDCardGeneratorMBTI.jsx";
import IDCardGeneratorGUP from "./pages/IDCardGeneratorGUP.jsx";
import IDCardGeneratorDev from "./pages/IDCardGeneratorDev.jsx";
import ITRoleCardGenerator from "./pages/IDCardGeneratorIT.jsx";
import MBTIProfilePicGenerator from './pages/MBTIProfilePicGenerator';
import TritypeGenerator from './pages/TritypeGenerator.jsx';
import CoupleCardGenerator from './pages/CoupleCardGenerator.tsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mbti" element={<IDCardGeneratorMBTI />} />
        <Route path="/gup" element={<IDCardGeneratorGUP />} />
        <Route path="/developer" element={<IDCardGeneratorDev />} />
        <Route path="/it" element={<ITRoleCardGenerator />} />
   <Route path="/pp" element={<MBTIProfilePicGenerator />} />
     <Route path="/tritype" element={<TritypeGenerator />} />
       <Route path="/couple" element={<CoupleCardGenerator />} />
      </Routes>
    </Router>
  );
}

export default App;
